import PropTypes from 'prop-types'

import { Container, Map } from 'common/widgets'
import classNames from './styles.module.scss'


SinglePageMapView.propTypes = {
  data: PropTypes.object.isRequired,
}

export default function SinglePageMapView({ data }) {
  return (
    <Container
      size="xl"
      className={classNames.mapContainer}
    >
      <Map position={data} />
    </Container>
  )
}
